export default __webpack_public_path__ + "static/media/moot-court-5.af363161.webp";